import { render } from "./darsa.vue?vue&type=template&id=552b3200"
import script from "./darsa.vue?vue&type=script&lang=js"
export * from "./darsa.vue?vue&type=script&lang=js"
script.render = render

export default script